<template>
    <!-- <div style="width: 80vw; height: 80vh;">
        <iframe width="100%" height="100%" :src="url" frameborder="0" border="0" marginwidth="0" marginheight="0"
            scrolling="no" allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen"
            msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen"
            webkitallowfullscreen="webkitallowfullscreen" security="restricted"
            sandbox="allow-same-origin allow-forms allow-scripts"></iframe>
    </div> -->
    <!-- https://fengchedmp.com/index.php/vod/play/id/18877/sid/1/nid/2.html -->
    <!-- <iframe width="100%" height="100%"
        src="https://basket.yhdmok.com/player/index.php?code=qw&amp;if=1&amp;url=https://svip.high20-playback.com/20240416/38003_3a15abc4/index.m3u8"
        frameborder="0" border="0" marginwidth="0" marginheight="0" scrolling="no" allowfullscreen="allowfullscreen"
        mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen"
        oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen" security="restricted"
        sandbox="allow-same-origin allow-forms allow-scripts"></iframe> -->

    <el-card style="width: 80vw; height: 100vw;">
        <div style="width: 80vw; height: 80vh;">

            <iframe width="100%" height="100%"
                src="https://basket.yhdmok.com/player/index.php?code=qw&amp;if=1&amp;url=https://svip.high20-playback.com/20240416/38003_3a15abc4/index.m3u8"
                frameborder="0" border="0" marginwidth="0" marginheight="0" scrolling="no" allowfullscreen="allowfullscreen"
                mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen"
                oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen" security="restricted"
                sandbox="allow-same-origin allow-forms allow-scripts">
            </iframe>
        </div>

        <template #footer>Footer content</template>
    </el-card>

    <div class="player-list" style="display: flex; justify-content: center; width: 100%;">
        <el-tabs type="card" lazy="true">
            <el-tab-pane label="路线一">
                <el-card style="width: 80vw">
                    <div style="display: grid; grid-template-columns: repeat(4, 1fr); grid-gap: 10px;">
                        <a class="player-item" v-for="item in 6" :key="item"
                            style="border: 1px solid; border-radius: 5px;">
                            <!-- <el-tag effect="plain"> -->
                            {{ item }}
                            <!-- </el-tag> -->
                        </a>
                    </div>
                </el-card></el-tab-pane>
            <el-tab-pane label="路线二">
                <el-card style="width: 80vw">
                    <div style="display: grid; grid-template-columns: repeat(4, 1fr); grid-gap: 10px;">
                        <a class="player-item" v-for="item in 6" :key="item"
                            style="border: 1px solid; border-radius: 5px;">
                            <!-- <el-tag effect="plain"> -->
                            {{ item }}
                            <!-- </el-tag> -->
                        </a>
                    </div>
                </el-card>
            </el-tab-pane>
        </el-tabs>
    </div>


</template>

<script>
export default {
    name: 'vedio',
    data() {
        return {
            url: 'https://pig.xn--15tz3lfwpxsj.xn--fiqs8s/?url=https://pig.yhvod.top/无名记忆/04.mp4',
            url_2: 'http://v2.shenjw.com:8022/wap.php?url=aq8524__v4963396179759218913827716532416272_z5ylphrxm_v10033g50000cpetlgnog65thb7thvb0cnit'
        }
    },

}
</script>

<style scoped>
.player-item {
    padding-bottom: 5px;
    padding-top: 5px;
    cursor: pointer;
}

.player-item:hover {
    color: rgb(230, 120, 53);
    /* background-color: rgb(187, 143, 116); */
}
</style>

<style>
.el-tabs__header {
    margin: 0;
}

.el-tabs__nav {
    float: right;
}

.el-card__body {
    padding: 0;
}
</style>